import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const InfoDialog = ({ config, close, title, infoHTML, titleStyles = { fontWeight: "900", fontSize: "36px" }, wrapperStyles = { maxWidth: "560px", minWidth: "340px", padding: "20px 36px" } }) => {
    return (
        <Dialog open={config.show ?? false} sx={{ "& .MuiDialog-paper": wrapperStyles }}>
            <DialogTitle sx={titleStyles}>{title}</DialogTitle>

            <DialogContent>
                {infoHTML && (
                    <div
                        style={{
                            wordBreak: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: infoHTML,
                        }}
                    />
                )}
            </DialogContent>

            <DialogActions>
                <Button variant="contained" onClick={close} data-test-id="btn-cancel">
                    Zatvorite obavestenje
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InfoDialog;
